import React from 'react'

const DropdownOptionSkeleton = () => {
  return (
    <div className="mb-2 flex animate-pulse-fast flex-row gap-4">
      <div className="h-11 w-10 rounded-sm bg-gray-200"></div>
      <div className="flex w-full flex-col justify-center gap-2">
        <div className="h-2 max-w-[20%] rounded-sm bg-gray-200"></div>
        <div className="h-2 max-w-[20%] rounded-sm bg-gray-200"></div>
      </div>
    </div>
  )
}

export default DropdownOptionSkeleton
